import { type FC } from "react";
import { Heading } from "@root/shared/components/Heading";
import * as styles from "./styles.css";

type Props = {
  children: React.ReactNode;
  className?: string;
};

export const SectionHeading: FC<Props> = ({ children, className }) => (
  <div className={`${styles.container} ${className || ""}`}>
    <Heading size="medium" bold tag="h3">
      {children}
    </Heading>
  </div>
);
